
export function getRandomString(length: number, chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_") {
    let s = '';
    while (length--) s += chars[Math.floor(Math.random() * chars.length)];
    return s;
}
